import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import InsuraceNavigationIcon from 'Icons/NavigationItem/Insurance';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

const LazyInsuranceSettingsPage = React.lazy(() => import('./Pages'));

const insuranceSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.insurance.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.insurance.title',
            url: '/insurance-settings',
            Icon: InsuraceNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyInsuranceSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
    // Standalone item only appears when neither grouping surface is on: the Compliance Hub
    // groups the system compliances, and the Compliance Builder implies the Hub
    visibilityRule: {
        [LaunchDarklyFlags.ComplianceHub]: { $ne: true },
        [LaunchDarklyFlags.ComplianceBuilder]: { $ne: true },
    },
};

export default insuranceSettingsConfiguration;
